import type { UserDashboardRelationsHelperRelationStateType } from '@magma-app/magma-types/all';

/** Shared by the list and detail: blue asks for action, green records success. */
export const RELATION_STATE_COLORS: Record<
  UserDashboardRelationsHelperRelationStateType,
  string
> = {
  toContact: 'blue',
  contacted: 'grey',
  toConfirm: 'blue',
  waitingHelpee: 'grey',
  waitingTeam: 'grey',
  closedUnreviewed: 'grey',
  accepted: 'green',
  exchangeValidated: 'green',
  rejected: 'grey',
  reported: 'grey'
};

export const RELATION_STATE_ICONS: Partial<
  Record<UserDashboardRelationsHelperRelationStateType, string>
> = {
  toConfirm: 'check-circle',
  reported: 'flag'
};
